import { spawn, call, put, takeLatest } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import { activityActions } from '../../../application/actions/activity';

import api from '../../api/index';

const apiRequest = api(process.env.REACT_APP_HOST);

// CREATE
export function* createFetch(e) {
    yield put(activityActions.conexionCreate({connection:true}));
    try {
        const  params  = e.payload;
        const url = `activity/make`
        const response = yield call(
            apiRequest.post,
            url,
            {params}
        );

        // Extraigo todos los datos
        const { result } = response;
        if(result){
            yield put(activityActions.create({result}));
        }else{
            throw new Error()
        }
    } catch (err) {
        yield put(activityActions.errorCreate({error:true, message:err.message}));
    } finally {
        yield put(activityActions.conexionCreate({connection:false}));
    }
}


export function* watchFetchActivity() {
    yield takeLatest(activityActionsSaga.create.type,  createFetch);
}

export default function* rootSaga() {
    yield spawn(watchFetchActivity);
}

const create = createAction('activityActionsSaga/create');

export const activityActionsSaga = {
    create,
};
